module.exports = __webpack_public_path__ + "img/promo1.cb34b576.png";